function blogListFilter() {
  return {
    filters: [],
    activeFilter: "all",
    init() {
      // Récupérer les filtres du DOM
      this.filters = Array.from(
        document.querySelectorAll("[x-data] button")
      ).map((filterEl) => ({
        label: filterEl.querySelector("span").textContent.trim(),
        value:
          filterEl.getAttribute("x-text") === "filter.label"
            ? "dynamic"
            : filterEl.getAttribute("value"),
        icon: filterEl.querySelector("i").className,
      }));
    },
    get filteredCards() {
      if (this.activeFilter === "all") return this.cards;
      return this.cards.filter((card) => card.type === this.activeFilter);
    },
  };
}

export default blogListFilter;
